import React from "react";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import AutoExpandInput from "./AutoExpandInput";

export default function InputField({ type, ...props }) {
  if (type === "autoExpand") {
    return <AutoExpandInput {...props} />;
  }

  return (
    <FormControl fullWidth>
      <TextField type={type} {...props} />
    </FormControl>
  );
}
